import { createContext, useContext } from 'react';
import { useRealtimeSupervisorShiftManager, RealtimeSupervisorShiftManagerOptions } from '../lib/supabase/supervisor-shifts/realtimeSupervisorShiftManager';

interface RealtimeSupervisorShiftContextType {
  isConnected: boolean;
}

const RealtimeSupervisorShiftContext = createContext<RealtimeSupervisorShiftContextType | undefined>(undefined);

interface SupabaseRealtimeSupervisorShiftProviderProps extends RealtimeSupervisorShiftManagerOptions {
  children: React.ReactNode;
}

export function RealtimeSupervisorShiftProvider({ children, ...options }: SupabaseRealtimeSupervisorShiftProviderProps) {
  const { isConnected } = useRealtimeSupervisorShiftManager(options);

  return (
    <RealtimeSupervisorShiftContext.Provider value={{ isConnected }}>
      {children}
    </RealtimeSupervisorShiftContext.Provider>
  );
}

export function useSupabaseRealtimeSupervisorShift() {
  const context = useContext(RealtimeSupervisorShiftContext);
  if (context === undefined) {
    throw new Error('useSupabaseRealtimeSupervisorShift must be used within a RealtimeSupervisorShiftProvider');
  }
  return context;
}